import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'flex',
  'flex-wrap',
  'flex-grow',
  'relative',
  'justify-end',
  'items-center',
  'py-2',
  'pl-4',
  'pr-2',
  'capitalize',
  'lg:justify-normal',
  'lg:hidden'
);

interface Props {
  children: ReactNode;
}

const MenuToggler = ({ children }: Props) => (
  <div className={className}>{children}</div>
);

export default MenuToggler;
